/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */
import { CombineLatestOperator } from '../observable/combineLatest';
export function combineAll(project) {
    return function (source) { return source.lift(new CombineLatestOperator(project)); };
}
//# sourceMappingURL=combineAll.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/operators/combineAll.js
// module id = 2722
// module chunks = 2